import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { SmsSender } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/sms-sender" component={SmsSender} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsSender/routes.js